<source [media]="sourceTablet" [srcset]="tablet" />
<source [media]="sourceDesktop" [srcset]="desktop" />
@if (showImage) {
<img [src]="mobile" loading="lazy" (error)="onError($event)" />
} @else if (showRGBA) {
<div [ngStyle]="rgbaStyles" class="product-rgba-color"></div>
} @else {
<img src="/assets/images/no-image.svg" alt="placeholder" />
}
